import React from 'react';
import { MessageCircle } from 'lucide-react';
import { useDefineSearch, extractWord } from '../SearchBar';
import { ASK_EXAMPLES } from '../../data/vocabulary';
import Reveal from '../Reveal';

// Dark band: each question is run through the real search, and the word it
// resolves to is shown beside it so people can see how the search reads them
const AskNaturally = () => {
  const runSearch = useDefineSearch();

  return (
    <section aria-labelledby="ask-heading" className="bg-ink text-paper">
      <div className="wrap grid gap-12 py-16 md:py-24 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:items-center">
        <Reveal>
          <h2 id="ask-heading" className="font-display text-4xl leading-tight md:text-5xl">
            Ask naturally.
            <br />
            Discover precisely.
          </h2>
          <p className="mt-5 max-w-md text-lg leading-relaxed text-paper/75">
            Type a whole question, in English or mixed with Nepali, and the search finds the word you mean.
          </p>
        </Reveal>

        <Reveal delay={80} as="ul" className="grid gap-3 sm:grid-cols-2">
          {ASK_EXAMPLES.map((question, index) => (
            <li key={question} className={index % 2 === 1 ? 'sm:translate-y-6' : ''}>
              <button
                type="button"
                onClick={() => runSearch(question)}
                className="group flex w-full items-start gap-3 rounded-[1.5rem] rounded-bl-md bg-paper/[0.08] p-5 text-left transition-[background-color,transform] duration-200 hover:bg-paper/[0.14] active:scale-[0.98]"
              >
                <MessageCircle size={20} className="mt-0.5 shrink-0 text-tangerine" aria-hidden="true" />
                <span className="flex-1">
                  <span className="block text-lg leading-snug text-paper">{question}</span>
                  <span className="mt-2 block text-sm text-paper/60">
                    Looks up <span className="font-semibold text-paper/90">{extractWord(question)}</span>
                  </span>
                </span>
              </button>
            </li>
          ))}
        </Reveal>
      </div>
    </section>
  );
};

export default AskNaturally;
